import { createBrowserRouter, createHashRouter } from 'react-router-dom'

import Routes from './components/Routes'

let router
// This app runs under the path /ui, so the router needs to be aware of this.
if (window.location.pathname.startsWith(__STANDALONE_REACT_APP_PATH__)) {
  router = createBrowserRouter(Routes, {
    basename: __STANDALONE_REACT_APP_PATH__,
  })
} else {
  router = createHashRouter(Routes, {
    basename: '/',
  })
}

export default router
